import { Injectable } from "@angular/core";
import {StorageService} from './storage.service';

@Injectable()
export class SessionStorageService extends StorageService {
  public constructor() {
    super(sessionStorage);
  }
}
